import { Preferences } from "../../profile/objects/preferences";
import { COMMERCIAL_TRIP_MODULE } from "../constant/commercialConstant";
import { Column } from "../objects/column";

const subDomain = window.location.host.split('.')[0];
const domain = window.location.host.split('.')[1];
export const setCommercialTripListPreference = (new_preferences: Preferences[], state_columns: Column[]): { order_by: string, order: 'asc' | 'desc', columns: Column[], preferences: Preferences[] } => {
    const field_name: string[] = [];
    const columns: Column[] = [];
    const preferences: Preferences[] = [];
    let order_by = '-created_date';
    let order: 'asc' | 'desc' = 'asc';
    new_preferences.map((preference: Preferences) => {
        if (preference.module === COMMERCIAL_TRIP_MODULE) {
            if (!field_name.includes(preference.field_name)) {
                switch (preference.field_name) {
                    case 'TOTAL_PRICE':
                        columns.push({ label: 'total-price', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__total_cost', fixed_width: true, last_updated: false });
                        order_by = 'current_version__total_cost';
                        break;
                    case 'REMAINING_PRICE':
                        columns.push({ label: 'remaining-price', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__balance', fixed_width: true, last_updated: false });
                        order_by = 'current_version__balance';
                        break;
                    case 'MARGIN':
                        columns.push({ label: 'margin', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false });
                        order_by = '';
                        break;
                    case 'INVOICE':
                        columns.push({ label: 'invoice', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: true, last_updated: false });
                        order_by = '';
                        break;
                    case 'STATUS':
                        columns.push({ label: 'status', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__status', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__status' : order_by;
                        break;
                    case 'FOLDER':
                        columns.push({ label: 'folder', field_name: preference.field_name, checked: preference.active, order_by: 'trip_reference', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'trip_reference' : order_by;
                        break;
                    case 'EVENT':
                        if (domain !== 'tripmci') {
                            break;
                        }
                        columns.push({ label: 'event', field_name: preference.field_name, checked: preference.active, order_by: 'event__localization__name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'event__localization__name' : order_by;
                        break;
                    case 'FOR_USER':
                        if (domain !== 'tripmci') {
                            break;
                        }
                        columns.push({ label: 'folder-for', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__for_user__first_name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__for_user__first_name' : order_by;
                        break;
                    case 'LEAD_TRAVELER':
                        if (domain === 'tripmci') {
                            break;
                        }
                        columns.push({ label: 'lead-traveler', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__contact_traveler__last_name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__contact_traveler__last_name' : order_by;
                        break;
                    case 'DESTINATION':
                        if (domain === 'tripmci') {
                            break;
                        }
                        columns.push({ label: 'destination', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__destination__current_version__localization__name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__destination__current_version__localization__name' : order_by;
                        break;
                    case 'PAX_NUMBER':
                        columns.push({ label: 'pax', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'START_DATE':
                        columns.push({ label: 'start-date', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__start_date', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__start_date' : order_by;
                        break;
                    case 'END_DATE':
                        columns.push({ label: 'end-date', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__end_date', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__end_date' : order_by;
                        break;
                    case 'USER_TO':
                        if (subDomain === 'marcovasco') {
                            break;
                        }
                        columns.push({ label: domain === 'tripmci' ? 'agent' : subDomain === 'cercledesvoyages' || subDomain === 'continentsinsolites' ? 'bo-agent' : 'to-agent', field_name: preference.field_name, checked: preference.active, order_by: 'user_to__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'user_to__username' : order_by;
                        break;
                    case 'USER_TA':
                        if (domain === 'tripmci' || subDomain === 'marcovasco') {
                            break;
                        }
                        columns.push({ label: subDomain === 'cercledesvoyages' || subDomain === 'continentsinsolites' ? 'seller' : 'agency-agent', field_name: preference.field_name, checked: preference.active, order_by: 'user_ta__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'user_ta__username' : order_by;
                        break;
                    case 'CONFIRMATION_DATE':
                        if (subDomain !== 'marcovasco') {
                            break;
                        }
                        columns.push({ label: 'confirmation-date', field_name: preference.field_name, checked: preference.active, order_by: 'current_version__confirmation_date', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'current_version__confirmation_date' : order_by;
                        break;
                    case 'QUOTATION_NAME':
                        columns.push({ label: 'quotation-name', field_name: preference.field_name, checked: preference.active, order_by: 'name', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'name' : order_by;
                        break;
                    case 'TO_AGENCY':
                        if (domain === 'tripmci' || subDomain === 'cercledesvoyages' || subDomain === 'continentsinsolites') {
                            break;
                        }
                        columns.push({ label: 'to-agency', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'VISIBILITY':
                        if (subDomain !== 'verdie' && subDomain !== 'beachcomber') {
                            break;
                        }
                        columns.push({ label: 'visible-to-agency', field_name: preference.field_name, checked: preference.active, order_by: '', fixed_width: false, last_updated: false });
                        break;
                    case 'CREATED_DATE':
                        columns.push({ label: 'created-date', field_name: preference.field_name, checked: preference.active, order_by: 'created_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'created_date' : order_by;
                        break;
                    case 'CREATED_BY':
                        columns.push({ label: 'created-by', field_name: preference.field_name, checked: preference.active, order_by: 'creator__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'creator__username' : order_by;
                        break;
                    case 'MODIFIED_DATE':
                        columns.push({ label: 'modified-date', field_name: preference.field_name, checked: preference.active, order_by: 'modified_date', fixed_width: true, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'modified_date' : order_by;
                        break;
                    case 'MODIFIED_BY':
                        columns.push({ label: 'modified-by', field_name: preference.field_name, checked: preference.active, order_by: 'last_author__username', fixed_width: false, last_updated: false });
                        order_by = preference.ordering_asc !== null ? 'last_author__username' : order_by;
                        break;
                    default:
                        break;
                }
                preferences.push(preference);
                field_name.push(preference.field_name);
                order = preference.ordering_asc !== null ? preference.ordering_asc ? 'asc' : 'desc' : order;
            }
        }
    });
    if (columns.length !== state_columns.length) {
        state_columns.map(column => {
            let added = false;
            for (let i = 0; i < columns.length; i++) {
                if (columns[i].label === column.label) {
                    added = true;
                    break;
                }
            }
            if (!added) {
                columns.push({ ...column });
            }
        });
    }
    return { order_by, order, columns, preferences };
};